import { render, staticRenderFns } from "./ScreeningCustomer.vue?vue&type=template&id=cfa65f04&scoped=true&"
import script from "./ScreeningCustomer.vue?vue&type=script&lang=js&"
export * from "./ScreeningCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningCustomer.vue?vue&type=style&index=0&id=cfa65f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa65f04",
  null
  
)

export default component.exports